module.exports = __webpack_public_path__ + "img/ModuleSetupCheckList.0ab5cbb4.png";